var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6338 5.96667C14.0754 5.35 13.2338 4.99167 12.0671 4.86667V4.23334C12.0671 3.09167 11.5838 1.99167 10.7338 1.225C9.87544 0.44167 8.75877 0.0750034 7.60044 0.183337C5.60877 0.375003 3.93377 2.3 3.93377 4.38334V4.86667C2.76711 4.99167 1.92544 5.35 1.36711 5.96667C0.558772 6.86667 0.583773 8.06667 0.675439 8.9L1.25877 13.5417C1.43377 15.1667 2.09211 16.8333 5.67544 16.8333H10.3254C13.9088 16.8333 14.5671 15.1667 14.7421 13.55L15.3254 8.89167C15.4171 8.06667 15.4338 6.86667 14.6338 5.96667ZM7.71711 1.34167C8.55044 1.26667 9.34211 1.525 9.95877 2.08334C10.5671 2.63334 10.9088 3.41667 10.9088 4.23334V4.81667H5.09211V4.38334C5.09211 2.9 6.31711 1.475 7.71711 1.34167ZM5.01711 9.45834H5.00877C4.55044 9.45834 4.17544 9.08334 4.17544 8.625C4.17544 8.16667 4.55044 7.79167 5.00877 7.79167C5.47544 7.79167 5.85044 8.16667 5.85044 8.625C5.85044 9.08334 5.47544 9.45834 5.01711 9.45834ZM10.8504 9.45834H10.8421C10.3838 9.45834 10.0088 9.08334 10.0088 8.625C10.0088 8.16667 10.3838 7.79167 10.8421 7.79167C11.3088 7.79167 11.6838 8.16667 11.6838 8.625C11.6838 9.08334 11.3088 9.45834 10.8504 9.45834Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartFilled);
export default __webpack_public_path__ + "static/media/cart-filled.fbbeed600610a879b9143b1a7bc88a6d.svg";
export { ForwardRef as ReactComponent };